import { Routes } from "@angular/router";
import { authGuard } from "@app/common/guards/auth.guard";

export const PORTFOLIO_MANAGEMENT_TABS = ["automations", "alerts", "notes", "memory", "schedules"] as const;

/** Mount before portfolio/:tab; these pages require sign-in, not a selected book. */
export const portfolioManagementRoutes: Routes = PORTFOLIO_MANAGEMENT_TABS.map((tab) => ({
  path: `portfolio/${tab}`,
  canActivate: [authGuard],
  data: { portfolioTab: tab },
  loadComponent: () => import("./portfolio-management.component").then((m) => m.PortfolioManagementComponent),
}));

/** Legacy memory URLs meant Trader Notes before agent memory was introduced. */
export const portfolioManagementRedirects: Routes = [
  { path: "settings/notes", redirectTo: "portfolio/notes", pathMatch: "full" },
  { path: "settings/automations", redirectTo: "portfolio/automations", pathMatch: "full" },
  { path: "settings/schedules", redirectTo: "portfolio/schedules", pathMatch: "full" },
  { path: "settings/memory", redirectTo: "portfolio/notes", pathMatch: "full" },
  { path: "memory", redirectTo: "portfolio/notes", pathMatch: "full" },
];
